<template>
	<div class="sf-account-containter w-100 h-100">
		<div class="row no-gutters h-100 w-100">
			<div class="col-lg-8"></div>
			<div class="col-lg-4 sf-account-right">
				<div class="sf-account-form">
					<div class="sf-account-form__header">
						<div class="sf-account__logo">
							<div class="blind">LOGO</div>
						</div>
						<div class="sf-account__logo__title">{{ systemName }}</div>
						<!-- <p class="title hd_head-24_1">{{ systemName }}</p> -->
					</div>
					<div class="sf-account-form__contents">
						<div class="sf-account-form__item">
							<div class="col-lg-10">
								<div class="sf-account-form__title">
									<!-- 다국어: 비밀번호 초기화 -->
									<h2 class="hd_head-30_1">{{ getMessage_('SWCC000460') }}</h2>
								</div>
								<div class="sf-account-form__input">
									<span class="hd_head-18_1">ID</span>
									<el-input
										:placeholder="getMessage_('SWCC000455')"
										v-model="userId"
										@keyup.enter.native="initPasswordAction"
										@input="e => input(e, 'userId')"
									/>
								</div>
							</div>
						</div>

						<div class="sf-account-form__item">
							<div class="col-lg-10">
								<div class="sf-account-form__input">
									<!-- 다국어: 이메일을 입력해주세요. -->
									<span class="hd_head-18_1">Email</span>
									<el-input
										type="email"
										:placeholder="getMessage_('SWCC000459')"
										v-model="email"
										@keyup.enter.native="initPasswordAction"
										@input="e => input(e, 'email')"
									/>
								</div>
							</div>
						</div>

						<div class="sf-account-form__item">
							<div class="col-lg-10">
								<div class="sf-account-form__btn">
									<!-- 다국어: 비밀번호 초기화 -->
									<button type="button" @click="initPasswordAction">{{ getMessage_('SWCC000460') }}</button>
								</div>
							</div>
						</div>

						<div class="sf-account-form__copyright">
							<div class="hd_text-12_1">{{ copyright }}</div>
							<div class="hd_text-12_2">{{ icpNo }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
//비밀번호 초기화 페이지
import { rootComputed, rootMethods } from '@/store/common/helpers';
import * as yup from 'yup';

export default {
	data() {
		return {
			userId: '',
			email: ''
		};
	},

	computed: {
		...rootComputed,

		systemName() {
			return process.env.VUE_APP_SYSTEM_NAME;
		},

		copyright() {
			return process.env.VUE_APP_COPYRIGHT;
		},

		icpNo() {
			return process.env.VUE_APP_ICP_NO;
		},

		schema() {
			return yup.object().shape({
				userId: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000359')])), //{0}은(는) 팔수 입력 값 입니다. , ID
				email: yup
					.string()
					.nullable()
					.email(this.getMessage_('SWCC000036')) //아이이디와 메일주소를 확인해주세요.
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000406')])) //{0}은(는) 팔수 입력 값 입니다. , 이메일
			});
		}
	},
	methods: {
		...rootMethods,

		//input 한글 입력 방지
		input(e, target) {
			this[target] = e.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '');
		},

		//비밀번호 초기화 버튼 클릭시
		initPasswordAction() {
			try {
				this.userId = this.userId.trim();
				this.email = this.email.trim();

				this.schema.validateSync({ userId: this.userId, email: this.email });
				this.initPassword();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},

		//비밀번호 초기화
		initPassword() {
			this.$sf_toggleLoading(true);

			//비밀번호 초기화 Action 호출
			this.passwordInit_({
				userId: this.userId,
				email: this.email
			})
				.then(header => {
					//비밀번호 초기화 메일 발송 성공 시
					if (header.code === 0) {
						this.$router.push('/login').catch(() => {}); //로그인 페이지로 이동
					}
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>

<style></style>
